// The CMS menu tree is walked recursively below. A category that lists
// itself as its own (possibly indirect) child is real, dirty-CMS-data that
// happens in production but never shows up in local fixtures, and without a
// cycle guard it recurses until the call stack overflows on every single
// page (Menu/Footer render this on every route). PLATFORM-ALAKHBAR-3Q /
// PLATFORM-ALAKHBAR-3W.
//
// `ancestors` tracks only the current root-to-node path, not every node
// visited so far, so the same submenu object legitimately reused under two
// different parents still renders fully both times.
export default function menuItemModel(rawMenu, ancestors = new Set()) {
    function getTitle() {
        return rawMenu === null || rawMenu === void 0 ? void 0 : rawMenu.title;
    }
    function getUrl() {
        return rawMenu === null || rawMenu === void 0 ? void 0 : rawMenu.url;
    }
    function getColor() {
        return rawMenu === null || rawMenu === void 0 ? void 0 : rawMenu.icon;
    }
    function getSubmenus() {
        var _a, _b;
        if (!(rawMenu === null || rawMenu === void 0 ? void 0 : rawMenu.subMenus))
            return undefined;
        const pathWithSelf = new Set(ancestors).add(rawMenu);
        return (_b = (_a = rawMenu.subMenus) === null || _a === void 0 ? void 0 : _a.filter((menuItem) => !pathWithSelf.has(menuItem))) === null || _b === void 0 ? void 0 : _b.map((menuItem) => menuItemModel(menuItem, pathWithSelf));
    }
    return {
        title: getTitle(),
        url: getUrl(),
        color: getColor(),
        subMenus: getSubmenus(),
    };
}
